<!-- 公共卡片组件 -->
<template>
    <div class="whiteCard commonCardBox" :style="{ height }">
        <template v-if="type == 'topCard'">
            <div class="cardTitle whiteCardText ellipsis">{{ title }}</div>
            <div class="cardContent ellipsis" :style="{color: contentColor}">{{ content }}</div>
            <div class="cardBottom">
                <template v-if="hasBg">
                    <div class="cardIconBg"
                        :style="{ backgroundColor: bgColor, width: iconBgSize, height: iconBgSize }">
                        <i class="iconfont" :class="icon" :style="{ fontSize: iconSize, color: iconColor }"></i>
                    </div>
                </template>
                <template v-else>
                    <i class="iconfont" :class="icon" :style="{ fontSize: iconSize, color: iconColor }"></i>
                </template>
            </div>
        </template>
        <template v-else-if="type == 'bottomCard'">
            <div class="cardBottom">
                <template v-if="hasBg">
                    <div class="cardIconBg"
                        :style="{ backgroundColor: bgColor, width: iconBgSize, height: iconBgSize }">
                        <i class="iconfont" :class="icon" :style="{ fontSize: iconSize, color: iconColor }"></i>
                    </div>
                </template>
                <template v-else>
                    <i class="iconfont" :class="icon" :style="{ fontSize: iconSize, color: iconColor }"></i>
                </template>
            </div>
            <div class="cardContent ellipsis" :style="{color: contentColor}">{{ content }}</div>
            <div class="cardTitle whiteCardText ellipsis">{{ title }}</div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        // 卡片类型，默认为topCard，可选值为topCard、bottomCard
        type: {
            type: String,
            default: "topCard",
        },
        // 卡片高度 - 默认为72px
        height: {
            type: String,
            default: "72px",
        },
        // 卡片标题
        title: {
            type: String,
            default: "",
        },
        // 卡片内容
        content: {
            type: String,
            default: "",
        },
        // 卡片内容颜色 - 默认为空 - 使用类名里面的蓝色
        contentColor: {
            type: String,
            default: "",
        },
        // 卡片图标 - iconfont的类名
        icon: {
            type: String,
            default: "",
        },
        // 卡片图标大小 - 默认为24px
        iconSize: {
            type: String,
            default: "12px",
        },
        // 卡片图标颜色 - 默认为rgba(128, 128, 128, 1)
        iconColor: {
            type: String,
            default: "rgba(128, 128, 128, 1)",
        },
        // 卡片背景颜色 - 默认为rgba(255, 255, 255, 1)
        bgColor: {
            type: String,
            default: "rgba(237, 239, 242, 1)",
        },
        // 卡片背景大小(宽&高) - 默认为20px
        iconBgSize: {
            type: String,
            default: "20px",
        },
        // 卡片背景是否需要
        hasBg: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped>
.commonCardBox {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    padding: 6px !important;
}

.cardTitle {
    width: 100%;
    display: block;
}

.cardContent {
    width: 100%;
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: var(--h5-color-blue);
}

.cardBottom {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.cardIconBg {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>